import { toCtaData } from "@/contents/converters/atoms"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import {
  ImageCarouselItem,
  MultiCarousel as MultiCarouselSanity,
} from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import MultiCarousel, { MultiCarouselSlide } from "@/ui/organisms/MultiCarousel"

export interface SanityMultiCarouselProps {
  content: MultiCarouselSanity
}

const toMultiCarouselSlide = (item: ImageCarouselItem): MultiCarouselSlide => ({
  content: <SanityImageField asset={item.image} />,
  link: item.link,
  linkTarget: "_blank",
})

const SanityMultiCarousel = ({ content }: SanityMultiCarouselProps) => {
  if (!content.carousels?.length) {
    return <></>
  }

  return (
    <BlokWrapper contents={content} menuColor="dark">
      <MultiCarousel
        carousels={
          content.carousels?.map(
            (carousel: any) =>
              ({
                title: <SanityRichTextField value={carousel.title} />,
                color: carousel.color ? carousel.color : undefined,
                cta: carousel.cta?.[0] ? toCtaData(carousel.cta[0]) : undefined,
                maxSlidesMd: parseInt(
                  carousel.maxSlidesMd ?? carousel.maxSlidesXs ?? "1"
                ),
                maxSlidesXs: parseInt(carousel.maxSlidesXs ?? "1"),
                width: carousel.carouselWidth,
                slides: carousel.items?.map(toMultiCarouselSlide) ?? [],
              }) ?? []
          ) ?? []
        }
      />
    </BlokWrapper>
  )
}

export default SanityMultiCarousel
